import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Text } from "@redotech/redo-web/text";
import { getExpandedItems } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries.pickableBinCount;

export const PickableBinCountColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const lineItems = row.lineItemPickability;
    if (!lineItems || lineItems.length === 0) {
      return null;
    }
    const anyDefined = lineItems.some(
      (li) => typeof li.pickableBinCount === "number",
    );
    if (!anyDefined) {
      return null;
    }
    const sum = lineItems.reduce(
      (total, li) => total + (li.pickableBinCount ?? 0),
      0,
    );
    return (
      <Flex align="flex-start" pl="lg">
        <Text fontSize="xs" textColor={sum === 0 ? "error" : "primary"}>
          {sum}
        </Text>
      </Flex>
    );
  },
  renderExpandedCell: ({ row, expansionIndex }) => {
    const lineItems = row.lineItemPickability;
    if (!lineItems || lineItems.length === 0) {
      return null;
    }
    const expandedItem = getExpandedItems(row)[expansionIndex];
    if (!expandedItem) {
      return null;
    }
    const item = lineItems.find(
      (li) => li.externalId === expandedItem.externalId,
    );
    if (!item || typeof item.pickableBinCount !== "number") {
      return null;
    }
    const count = item.pickableBinCount;
    return (
      <Flex align="flex-start" pl="lg">
        <Text fontSize="xs" textColor={count === 0 ? "error" : "primary"}>
          {count}
        </Text>
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
};
